var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0895 0H2.38096C1.06808 0 0 1.15652 0 2.57812V16.1719C0 17.5935 1.06808 18.75 2.38096 18.75H14.4301C15.1425 18.75 15.8124 18.4496 16.3162 17.904L17.6892 16.4173C18.193 15.8718 18.4705 15.1465 18.4705 14.375V2.57812C18.4705 1.15652 17.4024 0 16.0895 0ZM2.38096 1.25H16.0895C16.7659 1.25 17.3161 1.84578 17.3161 2.57812V4.375H1.1544V2.57812C1.1544 1.84578 1.70462 1.25 2.38096 1.25ZM1.1544 16.1719V5.625H17.3161V13.75H15.5123C14.5973 13.75 13.8529 14.5561 13.8529 15.5469V17.5H2.38096C1.70462 17.5 1.1544 16.9042 1.1544 16.1719ZM16.8729 15.5335L15.4999 17.0202C15.3565 17.1755 15.1893 17.2958 15.0073 17.3771V15.5469C15.0073 15.2453 15.2338 15 15.5123 15H17.2025C17.1274 15.1971 17.0164 15.3782 16.8729 15.5335Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.43 8.125C14.43 7.77984 14.1716 7.5 13.8528 7.5H4.61761C4.29881 7.5 4.04041 7.77984 4.04041 8.125C4.04041 8.47016 4.29881 8.75 4.61761 8.75H13.8528C14.1716 8.75 14.43 8.47016 14.43 8.125Z",
    fill: "#3CB4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6985 10.625H5.77203C5.45323 10.625 5.19482 10.9048 5.19482 11.25C5.19482 11.5952 5.45323 11.875 5.77203 11.875H12.6985C13.0173 11.875 13.2757 11.5952 13.2757 11.25C13.2757 10.9048 13.0173 10.625 12.6985 10.625Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedCommentIcon);
export default __webpack_public_path__ + "static/media/rejectedCommentIcon.bb29f03a8fff9d388cbd06f72875ffc9.svg";
export { ForwardRef as ReactComponent };